import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/services/auth.service";
import { UserInfoModel } from "src/app/model/user-info.model";
import { VersionService } from "src/app/services/version.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: [
    "./login.component.css",
    "../../../assets/fontello/css/animation.css",
  ],
})
export class LoginComponent implements OnInit {
  public usuario: UserInfoModel = new UserInfoModel();
  public loading: boolean = false;

  // Patrones de validacion de inputs
  public customPatterns = {
    U: { pattern: new RegExp("[a-zA-Z0-9.]") }, // user
    P: { pattern: new RegExp("[a-zA-Z0-9]") }, // pass
  };

  ////////////////
  constructor(
    private toastr: ToastrService,
    private auth: AuthService,
    private router: Router,
    private versionService: VersionService
    //private appRouting: AppRoutingModule
  ) { }

  ngOnInit() {
    this.usuario.applicationId = environment.appId;
    this.auth.logout();
  }

  login = () => {
    // validar
    if (
      !this.usuario.userId ||
      this.usuario.userId.length <= 0 ||
      !this.usuario.password ||
      this.usuario.password.length <= 0
    ) {
      this.toastr.info("Es necesario ingresar tanto usuario como contraseña.");
      return;
    }

    // mostrar spinner
    this.loading = true;

    this.versionService.getVersion();

    // enviar informacion
    this.auth.login(this.usuario).subscribe(
      async (resp: any) => {
        if (resp.codeHttpStatus === 200) {

          localStorage.setItem("UserId_2", this.usuario.userId);
          // localStorage.setItem("UserId", this.usuario.userId);
          localStorage.setItem("role", resp.data.role);

          //await this.appRouting.configureRoutesForRole(resp.data.role);

          console.log("Router: " + this.router);

          this.router.navigateByUrl("home/comisiones");

        } else {
          this.toastr.error("Los datos son incorrectos.");
          this.loading = false;
        }
      },
      (error) => {
        this.toastr.error("Error al autenticar.");
        this.loading = false;
      }
    );
  };
}
